import { styled, css } from "styled-components";

export const Wrapper = styled.div`
  pointer-events: none;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  * {
    --puck-color-azure-01: ${({ theme }) =>
      theme.colors.secondary[900]} !important;
    --puck-color-azure-02: ${({ theme }) =>
      theme.colors.secondary[800]} !important;
    --puck-color-azure-03: ${({ theme }) =>
      theme.colors.secondary[700]} !important;
    --puck-color-azure-04: ${({ theme }) =>
      theme.colors.secondary[600]} !important;
    --puck-color-azure-05: ${({ theme }) =>
      theme.colors.secondary[500]} !important;
    --puck-color-azure-06: ${({ theme }) =>
      theme.colors.secondary[400]} !important;
    --puck-color-azure-07: ${({ theme }) =>
      theme.colors.secondary[300]} !important;
    --puck-color-azure-08: ${({ theme }) =>
      theme.colors.secondary[200]} !important;
    --puck-color-azure-09: ${({ theme }) =>
      theme.colors.secondary[100]} !important;
    --puck-color-azure-10: ${({ theme }) =>
      theme.colors.secondary[50]} !important;
    --puck-color-azure-11: ${({ theme }) =>
      theme.colors.secondary[50]} !important;
    --puck-color-azure-12: ${({ theme }) =>
      theme.colors.secondary[50]} !important;
  }
`;

export const Container = styled.div<{
  $hasEditPermission?: boolean;
}>`
    pointer-events: all;
    position: relative;
    z-index: 1;
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.base};
    color: ${({ theme }) => theme.colors.default.default};

    * {
        pointer-events: all;
        ${({ $hasEditPermission }) =>
          $hasEditPermission
            ? css`
                ._DraggableComponent-actions_59z7f_97 {
                  transform: scale(var(--scale)) !important;
                }

                &[data-rfd-droppable-context-id] {
                  min-height: 40px !important;
                }
              `
            : css`
                ._DraggableComponent-actions_59z7f_97 {
                  display: none !important;
                }
              `};
`;

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.default[100]};
  border-right: 1px solid ${({ theme }) => theme.colors.default[400]};
  color: ${({ theme }) => theme.colors.primary.default};
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SecondaryPageLayout = styled.div`
  height: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.secondary[100]};

  ._DraggableComponent-actions_59z7f_97 {
    display: none !important;
  }

  > * {
    flex: 1;
  }

  ${Container} {
    outline: 2px dashed ${({ theme }) => theme.colors.secondary.default};
  }
`;
